<template>
  <vue-final-modal
    :value="session.paypayNoticeVisible"
    name="open_paypay_eprint_modal"
    :classes="['eprint-paypay-notice__container']"
    :styles="{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }"
    :content-class="[
      'eprint-paypay-notice__content',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    :z-index-base="10050"
    @input="session.paypayNoticeVisible = $event"
  >
    <div class="v--modal-close-top">
      <el-button
        icon="el-icon-close"
        type="text"
        @click="session.paypayNoticeVisible = false"
      />
    </div>
    <div class="title" style="text-align: center; color: rgb(231 54 0)">
      決済しただけでは注文は完了しません
    </div>
    <br />
    <span
      >注文を完了するにはPayPay決済画面の「ご利用中のサービスに戻る」ボタンを押下してください。</span
    >
    <div style="width: 100%">
      <img
        src="/static/renew2_img/paypay_alert_image_20240214.png"
        style="width: 100%"
      />
    </div>
    <div class="text-center">
      <el-button
        type="primary"
        style="width: 100%; height: 70px"
        @click="actions.openPayPayEprintSite"
        >注意事項を理解し、決済サービスを開く</el-button
      >
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import {
  useEprintActions,
  useEprintSession
} from '@/composables/format-edit/useEprintSession'

const session = useEprintSession()
const actions = useEprintActions()
</script>
